import { CdkMenuModule } from '@angular/cdk/menu';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { UserData } from '../header';
import { RouterLink } from '@angular/router';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SobreComponent } from '../../sobre/sobre.component';
import { MatDialog } from '@angular/material/dialog';
import { ShowIfAuthorizedModule } from 'src/app/directives/show-if-authorized/show-if-authorized.module';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu-user',
  imports: [CdkMenuModule, NgIcon, RouterLink, ShowIfAuthorizedModule],
  templateUrl: './menu-user.component.html',
  styleUrl: './menu-user.component.scss'
})
export class MenuUserComponent {
  private apiUsuario = inject(ApiUsuarioService);
  private utilsService = inject(UtilsService);
  private dialog = inject(MatDialog);

  @Output() logoutEmitter = new EventEmitter<void>();
  @Input() menuRef!: any;
  @Input() avatar!: string;
  @Input() userData!: UserData;
  @Input() initialsName: string = "";
  @Input() isAlternativeAvatar = false;

  public isAuthorizedIA: boolean = !environment.production && !this.utilsService.isMobileDevice() ? true : false;

  protected isUserAdmin: boolean = this.apiUsuario.isUserAdmin();

  public logoutEventEmitter = () => {
    this.logoutEmitter.emit();
  }

  protected redirectToCentral = () => {
		if (this.apiUsuario.urlCentral == null) {
      window.open("https://central.agger.com.br/Atendimento", '_blank');
			return;
		}
		window.open(this.apiUsuario.urlCentral, "_blank");
	}


  protected openModalAbout = () => {
    this.dialog.open(SobreComponent, {
      panelClass: 'modalDefault'
    })
  }

  	downloadTeamViewer() {
   		const isMac = navigator.platform?.toLowerCase().includes("mac");

		const url = isMac
  		? "https://instala.agger.com.br/TeamViewer.dmg"
  		: "https://instala.agger.com.br/remoto.exe";

		window.location.href = url;
	}

}
